import { type PropsWithChildren } from 'react'
import * as S from './BlurryBackground.styles'

export default function BlurryBackground({
  children,
  show,
  onClick,
  backgroundColor,
  backdropFilter,
}: PropsWithChildren<{
  show: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void
  backgroundColor?: string
  backdropFilter?: string
}>) {
  return (
    <S.BlurryBackground
      onClick={onClick}
      $display={show}
      $backgroundColor={backgroundColor}
      $backdropFilter={backdropFilter}
    >
      {children}
    </S.BlurryBackground>
  )
}
